import api from './client';

export interface CloudflareConfig {
  apiTokenMasked: string;
  credentialsConfigured: boolean;
  accountId: string | null;
  accountName: string | null;
  zoneId: string | null;
  zoneName: string | null;
  tunnelId: string | null;
  tunnelName: string | null;
  hostname: string | null;
  localTarget: string;
  serviceStatus: 'running' | 'stopped' | 'not_installed' | 'unknown' | 'error' | null;
  serviceStatusUpdatedEm: string | null;
  binarioInstalado: boolean;
  binarioPath: string;
}

export interface CloudflareZone {
  id: string;
  name: string;
  accountId: string | null;
  accountName: string | null;
}

export interface CredentialsValidationResult {
  accountId: string;
  accountName: string;
  zonesCount: number;
}

export interface SetupResult {
  hostname: string;
  tunnelId: string;
  serviceStatus: string | null;
}

class CloudflareApi {
  async getConfig(): Promise<CloudflareConfig> {
    const r = await api.get<CloudflareConfig>('/cloudflare/config');
    return r.data;
  }
  async saveCredentials(apiToken: string): Promise<CredentialsValidationResult> {
    const r = await api.post<CredentialsValidationResult>('/cloudflare/credentials', { apiToken });
    return r.data;
  }
  async listZones(): Promise<CloudflareZone[]> {
    const r = await api.get<CloudflareZone[]>('/cloudflare/zones');
    return r.data;
  }
  async setup(zoneId: string, subdomain: string, tunnelName?: string): Promise<SetupResult> {
    const r = await api.post<SetupResult>('/cloudflare/setup', { zoneId, subdomain, tunnelName });
    return r.data;
  }
  async serviceStart() { return (await api.post('/cloudflare/service/start')).data; }
  async serviceStop() { return (await api.post('/cloudflare/service/stop')).data; }
  async serviceReinstall() { return (await api.post('/cloudflare/service/reinstall')).data; }
  async serviceStatus(): Promise<{ status: string }> {
    return (await api.get('/cloudflare/service/status')).data;
  }
  async teardown() { return (await api.delete('/cloudflare/tunnel')).data; }
}

export const cloudflareApi = new CloudflareApi();
